
 <!-- <div class="makepayment"> -->

    <!-- <v-container>
        <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline mx-auto mt-3">Make Payment</v-toolbar-title>
        </v-toolbar>

        
        <div class="mt-6">
            <v-card class="mx-auto elevation-5" color="#F0FFEA" max-width="500" flat> 
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Policy Holder</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            solo
                            flat
                            dense
                            v-model="username"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Bank Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            solo
                            flat
                            dense
                            v-model="bankName"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Account Number</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="accountNumber"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Account Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="accountName"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Description</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
            <v-textarea v-model="description" flat solo auto-grow="true" label=""></v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n4 pa-4">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Amount</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            solo
                            flat
                            dense
                            v-model="amount"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-layout class=" pa-4">
                <v-spacer></v-spacer>
                <v-btn color="#08911b" :loading="loading" to='/makepayments' class="white--text font-weigth-bold " style="font-size:14px" >
                    INITIATE PAYMENT
                </v-btn>
                
            </v-layout>
            </v-card>
        </div>

    </v-container> -->

<!-- </div>
</template> -->
<template>
    <div class="makepayment">
        <v-container fluid class="fill-height">
            <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
                <span>{{message}}</span>
                <v-btn text color="white" @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-row justify-center align="center" justify="center" app>
                <v-col cols="12" md="12" sm="12">
                    <v-card class="pa-7 mx-auto"  max-width="500px" elevation="7">
                        <h3 class="text-center" style="color:#27d2dc">Pay with card</h3>
                        <v-card-text class="mt-2">
                            <v-form ref="form">
                                
                                <v-text-field readonly outlined dense  label="Policy Holder"  v-model="username"
                                   >
                                </v-text-field>
                                <v-text-field readonly outlined dense  prepend-inner-icon="mdi-currency-ngn" small label="Amount" v-model="amount"
                                   >
                                </v-text-field>
                                
                                <v-textarea v-model="description" outlined auto-grow="true" label="Description"></v-textarea>

                                
                            </v-form>
                        </v-card-text>
                        <v-card-text class="text-center mt-n8">
                            <Rave
                                :email="fltEmail"
                                :reference="reference"
                                :amount="amount"
                                :rave-key="raveKey"
                                :callback="callback"
                                :close="close"
                                :metadata="meta"
                                :subaccounts="subaccounts"
                                :paymentPlan="plan"
                                :customerFirstname="fname"
                                :customerLastname="lname"
                                paymentOptions="card,barter,account,ussd"
                                hostedPayemt="1"
                                customTitle="Peer Cover Premium Payment"
                                currency="NGN"
                                country="NG"
                                
                            ><v-btn class="text-none" style="color:#27d2dc">Initiate Transfer</v-btn></Rave>
                            
                        </v-card-text>

                    </v-card>
                </v-col> 
               
                
            </v-row>
        </v-container>  
    </div>
</template>



<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';
import Rave from 'vue-ravepayment';
export default {
    name: 'makepayment',
    components: {
        Rave
    },
    data(){
        return{
            username: '',
            description: 'Premium Payment',
            amount: 0.0,
            reference:'',
            // ==================FLUTTER STUFFS======================
                fltEmail:'',
                loadFlt:false,
                raveKey:'FLWPUBK_TEST-2e36fe15dab9757843d16ab2731aba74-X',
                meta: [{
                    metaname: 'Peer Cover',
                    metavalue: this.description
                }],
                sub: [
                    {
                        id: "1324"
                    },
                    {
                        id: "1221"
                    }
                ],
                plan: 2928,
                fname:'',
                lname:''
            // ==========================FLW STUFFS STOP HERE=============
        }
    },
    methods:{
        callback: function(response){
                if(response.data.data.responsecode==="00"&& response.data.tx.txRef===this.reference){
                    let raveId = response.data.tx.id
                    let flwRef = response.data.tx.flwRef    
                    this.$store.dispatch("Flutterwave", {
                        "transactionId":this.reference,
                        "username":this.username,
                        "raveTransId":raveId,
                        "flwRef":flwRef
                    })
                    .then((success=>{
                        console.log(success)
                    }))
                    .catch((error)=>{
                        console.log(error.response)
                    })
                }else{
                    console.log('Something went wrong')
                }
                
            },
            close: function(){
                console.log("Payment closed")
            }
    },
    created(){
        // this.username = this.$store.state.claims.userclaimdetails[0].username
        // this.accountName = this.$store.state.claims.userclaimdetails[0].account_name
        // this.accountNumber = this.$store.state.claims.userclaimdetails[0].account_number
        // this.bankName = this.$store.state.claims.userclaimdetails[0].bankname
        // console.log(this.$store.state.community.viewclaims[0].consultant_claim_amount)
        // if(this.$store.state.community.viewclaims[0].consultant_claim_amount==="" || this.$store.state.community.viewclaims[0].consultant_claim_amount===null|| this.$store.state.community.viewclaims[0].consultant_claim_amount==='0.00'){
        //     let regex = /[.,\s]/g
        //     this.amount= this.$store.state.community.viewclaims[0].loss_assessor_claim_amount.replace(/[.,\s]/g, '')
        // }else{ 
        //     this.amount =this.$store.state.community.viewclaims[0].consultant_claim_amount.replace(/[.,\s]/g, '')
        // }
        this.username=this.$route.query.username;
        this.amount= this.$route.query.amount
        this.reference = this.$route.query.ref
        this.fltEmail = this.$route.query.email
        this.fname = this.$route.query.fname
        this.lname = this.$route.query.lname
        
    }
}
</script>


<style scoped>
.makepayment{
    background-color: #ffffff;
    height: 100%;
    background-size: cover;
}
.card-des{
    border: 2px solid green;
}

</style>